import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.widgets').directive('kissCompareTo', kissCompareTo);

    kissCompareTo.$inject = [];

    function kissCompareTo() {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: link,
            scope: {
                otherModelValue: '=kissCompareTo'
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                if (attrs.hasOwnProperty('ignoreCase')) {
                    return angular.lowercase(modelValue) === angular.lowercase(scope.otherModelValue.$viewValue);
                } else {
                    return modelValue === scope.otherModelValue.$viewValue;
                }
            };

            scope.$watch(
                function() {
                    return scope.otherModelValue ? scope.otherModelValue.$viewValue : undefined;
                },
                function() {
                    ngModel.$validate();
                }
            );
        }
    }
})();
